import styles from './Separator.module.scss';

export default function SeparatorComponent() {
    return (
        <div className={styles.redlSeparator}>
            <span className={styles.redlSeparatorLine}></span>
        </div>
    );
}